/**
 * Store complete book models (photos, backgrounds, stickers, etc...)
 */
fx.ns("repositories", class FrameRepository extends repositories.BaseRepository {

    constructor() 
    {
        super({
            creation: new models.ProductFrame({ id: "" }), // id empty so it's not created in db 
            zoom : new models.Zoom(),
        });

    }

    get frame()
    {
        return this.creation;
    }


    initData(data)
    {
        super.initData(data);

        this.frame.init(data.creation, {"CreationElement" : "ProductFramePage"});

        this.creation.creationOptions = data.creationOptions;
    }

});
